exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".modal__SearchCompanyAndUserComponent-module___fSuH5 {\n    background-color: #0000001d;\n}", ""]);

// Exports
exports.locals = {
	"modal": "modal__SearchCompanyAndUserComponent-module___fSuH5"
};